var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "544px"
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.isEditing ? _vm.$t('profile.team_members_action_edit_user') : _vm.$t('profile.team_members_invite_a_new_user')) + " ")]), _c('div', {
    staticClass: "mt-5 mx-7"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.nameLabel,
      "rules": [_vm.rules.required, _vm.rules.name],
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "label": _vm.emailLabel,
      "rules": [_vm.rules.required, _vm.rules.email],
      "required": "",
      "outlined": "",
      "dense": "",
      "disabled": _vm.isEditing
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1)], 1), _c('v-card-actions', {
    staticClass: "pb-5 mx-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    staticClass: "white--text ml-3 lightened-disabled",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid || _vm.isLoading
    },
    on: {
      "click": _vm.handleInvite
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? _vm.$t('save') : _vm.$t('profile.team_members_invite')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }